import { useTranslation } from 'react-i18next'

interface ManualEntryBetTypeProps<T> {
  betTypes: {
    key: T
    label: string
  }[]
  selectedBetTypes: T[]
  onToggle: (key: T) => void
}

const ManualEntryBetType = <T extends string>({
  betTypes,
  selectedBetTypes,
  onToggle,
}: ManualEntryBetTypeProps<T>) => {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col gap-4">
      <h5 className="text-[var(--caption-text)] text-base font-medium mb-2 text-center md:text-left">
        {t('betDetailPanel.selectBetType')}
      </h5>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3">
        {betTypes.map((type) => (
          <button
            key={type.key}
            onClick={() => onToggle(type.key)}
            className={`px-3 sm:px-4 py-2.5 sm:py-3 rounded-lg border font-semibold text-sm sm:text-base transition-all cursor-pointer  ${
              selectedBetTypes.includes(type.key)
                ? 'btn-active-state border-[var(--bet-type-active-border)]'
                : 'bg-[var(--bet-type-bg)] text-[var(--bet-type-text)] border-[var(--bet-type-border)] hover:bg-[var(--bet-type-hover-bg)] hover:text-[var(--bet-type-hover-text)] hover:border-[var(--bet-type-hover-border)]'
            }`}
          >
            {type.label}
          </button>
        ))}
      </div>
    </div>
  )
}

export default ManualEntryBetType
